import axiosApi from "../../components/Api/Axios";
import AuditDetailsView from "../../Models/Audit/AuditDetailsView";
import BackendServices from "../../components/Api/BackendService";
import { details as detailsPath } from "../../components/Paths/paths";

export default (id: string | number) =>
  axiosApi.get<AuditDetailsView>(
    `${BackendServices.AUDIT_SERVICE.AUDIT}/${id}${detailsPath}`
  );
